export const KEY_ENTER = "Enter";
export const KEY_ESCAPE = "Escape";
export const KEY_UP = "ArrowUp";
export const KEY_DOWN = "ArrowDown";
export const KEY_LEFT = "ArrowLeft";
export const KEY_RIGHT = "ArrowRight";
export const KEY_HOME = "Home";
export const KEY_END = "End";
export const KEY_SPACE = " ";
